import { FunctionComponent } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import AlternatingText from 'components/AlternatingText';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useFinished from './useFinished';

const Finished: FunctionComponent = () => {
  const {
    title,
    subtitleArray,
    line1,
    email,
    phone,
    hours,
    isExampleJob,
    exampleReturnUrl,
  } = useFinished();

  return (
    <PleaseWaitOverlay
      icon="check-circle-color"
      iconClassName="mb-4"
      title={title}
      labelLine1={<AlternatingText array={subtitleArray} />}
      labelLine2={
        <span>
          {line1[0]}
          <a
            href="mailto:help@kanda.co.uk"
            className="text-purple-400 underline font-semibold"
          >
            help@kanda.co.uk
          </a>
          {line1[1]}
        </span>
      }
      footer={
        <>
          <div className="grid grid-cols-[max-content_auto] gap-x-3 md:gap-x-4 gap-y-1 text-14-22 text-neutral-800 mt-2">
            <span className="font-semibold">Email: </span>
            <a
              href={`mailto:${email}`}
              className="text-purple-400 font-semibold underline"
            >
              {email}
            </a>
            <span className="font-semibold">Telephone: </span>
            <a
              href={`tel:${phone}`}
              className="text-purple-400 font-semibold underline"
            >
              {phone}
            </a>
            {hours && (
              <>
                <span className="font-semibold">Hours:</span>
                <div className="flex flex-col">
                  {hours.map((str: string) => (
                    <span key={str}>{str}</span>
                  ))}
                </div>
              </>
            )}
          </div>
          {isExampleJob && (
            <a href={exampleReturnUrl}>
              <Button.Text
                id="example-job"
                label="Back to dashboard"
                size={40}
                className="mt-4 w-full"
              />
            </a>
          )}
        </>
      }
    />
    // mt-2  mt:mb-4

    // <div className="flex flex-col w-full">
    //   <Icon {...ICON_PROPS} />
    //   <Text
    //     text={isIntroduced ? INTRODUCED_TITLE : TITLE}
    //     className={CLASS_NAMES.title}
    //   />
    //   {!isIntroduced && (
    //     <>
    //       <Text text={HEADER} className={CLASS_NAMES.subtitle} />
    //       <Text text={subtitle} className={CLASS_NAMES.subtitle} />
    //       <Text text={line1} className={CLASS_NAMES.subtitle} />
    //       <span className={CLASS_NAMES.subtitle}>
    //         {LINE_2}
    //         <a className="text-blue-200 underline " href={`mailto:${email}`}>
    //           {email}
    //         </a>
    //       </span>
    //       {hours && (
    //         <div className="flex flex-row">
    //           <Text text="Contact hours:" className={CLASS_NAMES.contact} />
    //           <div className="flex flex-col">
    //             {hours.map((str: string) => (
    //               <Text
    //                 key={str}
    //                 text={str}
    //                 className={CLASS_NAMES.contactHours}
    //               />
    //             ))}
    //           </div>
    //         </div>
    //       )}
    //     </>
    //   )}

    // </div>
  );
};

export default Finished;
